
<p-toolbar styleClass="bg-white border-noround shadow-2">
  <ng-template pTemplate="start">
    <div class="flex align-items-center gap-3">
<!--      <img-->
<!--        [src]="'logo' | iconPath"-->
<!--        alt="Special features"-->
<!--        width="126"-->
<!--        height="40"/>-->
      <app-logo></app-logo>
    </div>
  </ng-template>

  <ng-template pTemplate="end">
    <div class="flex align-items-center gap-3">
      <button
        class="theme-button"
        (click)="toggleTheme()">
        <img
          [src]="getIconPath('color-mode')"
          [alt]="themeService.isDarkMode() ? ('Light Mode' | translate) : ('Dark Mode' | translate)"
          width="20"
          height="20"/>
      </button>

      <button
        class="accessibility-button"
        (click)="toggleAccessibilityPanel()">
        <img
          [src]="'glasses' |iconPath"
          alt="Special features"
          width="20"
          height="20"/>
      </button>

      <div class="flex align-items-center gap-1">
        <app-select-language (languageSelected)="selectLanguage($event)"/>
      </div>

      <button
        class="help-button"
        (click)="helpMenu.toggle($event)">
        <img
          [src]="getIconPath('help')"
          alt="Help"
          width="20"
          height="20"/>
      </button>

      <p-menu #helpMenu [model]="helpMenuItems" [popup]="true">
        <ng-template pTemplate="item" let-item>
          <a class="p-menuitem-link" (click)="item.command ? item.command($event) : null">
            <span class="p-menuitem-text">{{ item.label  | translate }}</span>
          </a>
        </ng-template>
      </p-menu>

      <p-avatar
        [label]="userInitials"
        styleClass="cursor-pointer"
        shape="circle"
        (click)="profileMenu.toggle($event)">
      </p-avatar>

      <p-menu #profileMenu [model]="profileMenuItems" [popup]="true">
        <ng-template pTemplate="item" let-item>
          <a class="p-menuitem-link" (click)="item.command ? item.command($event) : null">
            <img
              alt="icon"
              *ngIf="item.icon && !item.icon?.startsWith('pi')"
                 [src]="item.icon"
                 class="p-menuitem-icon-svg"
                 width="16"
                 height="16"/>
            <span [class]="item.icon" *ngIf="item.icon && item.icon?.startsWith('pi')"></span>
            <span class="p-menuitem-text">{{ item.label  | translate }}</span>
          </a>
        </ng-template>
      </p-menu>
    </div>
  </ng-template>
</p-toolbar>

<app-visual-impairments-panel
  *ngIf="showAccessibilityPanel"
  (close)="onAccessibilityPanelClose()">
</app-visual-impairments-panel>

<p-confirmDialog></p-confirmDialog>
